import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/**
 * Catches render errors in route/page content so the shell (nav, menus) stays usable.
 * Parent should set key={location.pathname} so navigating away remounts and clears the error.
 */
export default class RouteErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, errorInfo) {
		console.error('RouteErrorBoundary', error, errorInfo);
		this.setState({ errorInfo });
	}

	handleRetry = () => {
		this.setState({ error: null, errorInfo: null });
	};

	render() {
		const { error, errorInfo } = this.state;
		if (error) {
			const message = error && typeof error.message === 'string' ? error.message : String(error);
			return (
				<div className="main ctnPage">
					<div className="alert alert-danger" role="alert">
						<h4 className="alert-heading">This page hit an error</h4>
						<p className="mb-0">
							Something went wrong while showing this screen. Your session and navigation are still available—pick another tool from the menu, try again here, or do a full reload.
						</p>
						<hr />
						<p className="mb-2 small font-weight-bold text-monospace">{message}</p>
						{process.env.NODE_ENV === 'development' && errorInfo && errorInfo.componentStack ? (
							<details className="small mt-2">
								<summary>Component stack (development only)</summary>
								<pre className="mt-2 mb-0" style={{ whiteSpace: 'pre-wrap', fontSize: '11px' }}>{errorInfo.componentStack}</pre>
							</details>
						) : null}
						<div className="mt-3">
							<button type="button" className="btn btn-primary mr-2" onClick={this.handleRetry}>
								Try again
							</button>
							<Link to="/" className="btn btn-outline-secondary mr-2">
								Home
							</Link>
							<button type="button" className="btn btn-outline-secondary" onClick={() => window.location.reload()}>
								Full reload
							</button>
						</div>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}
